import React, { useCallback } from 'react';
import { useModalControls } from 'state/modals';
import PodcastEpisodeEmptyInput from './PodcastEpisodeEmptyInput';
import PodcastEpisodeNonEmptyInput from './PodcastEpisodeNonEmptyInput';
import { EpisodeInputValue } from './types';
import YoutubeVideoNonEmptyInput from './YoutubeVideoNonEmptyInput';

export type PodcastEpisodeInputProps = {
  episode?: EpisodeInputValue;
  onChange?: (episode: EpisodeInputValue) => void;
};

const PodcastEpisodeInput = React.forwardRef<
  HTMLButtonElement,
  PodcastEpisodeInputProps
>(({ episode, onChange }, ref) => {
  const { open, close } = useModalControls();

  const handleModalOpen = useCallback(() => {
    open({
      name: 'PodcastSearch',
      params: {
        enableYoutubeUrl: true,
        onEpisodeSelected({ episodeId, podcast, thumbnailUrl, title }) {
          onChange?.({
            type: 'podcastEpisode',
            episodeId,
            podcast,
            thumbnailUrl,
            title,
          });
          close();
        },
        onYoutubeVideoSelected({ url, videoId, title }) {
          onChange?.({ type: 'youtubeVideo', url, videoId, title });
          close();
        },
      },
    });
  }, [close, onChange, open]);

  if (!episode) {
    return <PodcastEpisodeEmptyInput onPress={handleModalOpen} ref={ref} />;
  }

  if (episode.type === 'youtubeVideo') {
    return (
      <YoutubeVideoNonEmptyInput
        buttonRef={ref}
        video={episode}
        onSearchPress={handleModalOpen}
      />
    );
  }

  return (
    <PodcastEpisodeNonEmptyInput
      buttonRef={ref}
      episode={episode}
      onSearchPress={handleModalOpen}
    />
  );
});

export default PodcastEpisodeInput;
